module.exports = __webpack_public_path__ + "static/about-profile-wesleym-b02bd58d58e2a9d1ac087361ba17a301.png";